import { serviceHandler } from './service-executor';

const BILL_API = '/api/bills';

export const findBills = (driver, params, page, pageSize) => {
  let URL = `${BILL_API}/drivers/${driver}?page=${page}&pageSize=${pageSize}`;
  return serviceHandler(URL, 'POST', params);
};

export const processBillPayment = (payment) => {
  const URL = `${BILL_API}/pay`;
  return serviceHandler(URL, 'POST', payment);
};

export const unpayDriverLegs = (legIds) => {
  const idStr = legIds.join(); //string ids
  const URL = `${BILL_API}/${idStr}/unpay`;
  return serviceHandler(URL, 'GET');
};

export const getBillReport = (legIds, start, end) => {
  const idStr = legIds.join();
  const URL = `${BILL_API}/${idStr}/report?startDate=${start}&endDate=${end}`;
  return serviceHandler(URL, 'GET_BLOB');
};

export const saveCheck = (billId, check) => {
  const URL = `${BILL_API}/${billId}/check/save`;
  return serviceHandler(URL, 'POST', check);
};

export const save = (bill) => {
  console.log(bill);
};

export const update = (bill) => {
  console.log(bill);
};

export const getLastFivePayments = (driver) => {
  const URL = `${BILL_API}/drivers/${driver}/lastpayments`;
  return serviceHandler(URL, 'GET');
};